// import React, { useEffect } from 'react';
// import { 
//   Container, 
//   Paper, 
//   Typography, 
//   Divider, 
//   Box, 
//   List, 
//   ListItem, 
//   ListItemText 
// } from '@mui/material';

// const Privacyinfo = () => {
//   // पेज लोड झाल्यावर सर्वात वर स्क्रोल करण्यासाठी
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   const privacyPoints = [
//     "CCTV Partner respects your privacy and is committed to protecting your personal information.",
//     "We may collect limited personal information such as your name, mobile number, email address, and site details only for the purpose of providing and improving our surveillance services.",
//     "Your personal data will never be sold, rented, or shared with any third party without your consent, except where required by law.",
//     "We use secure servers, encryption, and modern security practices to safeguard your surveillance data and information.",
//     "You have the right to access, update, or request deletion of your personal data by contacting us.",
//     "Our services may include internet permissions for remote monitoring and cloud storage. No unnecessary data is collected in the background.",
//     "Our website may contain links to external platforms. We are not responsible for the privacy practices of those third-party services.",
//     "This service is intended for general audiences and does not knowingly collect data from children under 13 years of age.",
//     "We may update this Privacy Policy from time to time. Users are advised to review it periodically."
//   ];

//   return (
//     /* mt: 10 मुळे नेव्हबारच्या खाली जागा सुटेल */
//     <Box sx={{ bgcolor: '#081e35', minHeight: '100vh', pt: { xs: 10, md: 15 }, pb: 8 }}>
//       <Container maxWidth="md">
//         <Paper 
//           elevation={0} 
//           sx={{ 
//             p: { xs: 3, md: 6 }, 
//             borderRadius: '4px', 
//             bgcolor: '#0d2847', // App theme नुसार paper color
//             border: '1px solid rgba(30,144,212,0.2)' 
//           }}
//         >
          
//           {/* --- Section 1: Privacy Policy --- */}
//           <Box mb={6}>
//             <Typography 
//               variant="h3" 
//               gutterBottom 
//               sx={{ 
//                 fontWeight: 900, 
//                 color: '#fff', // Header white केला आहे
//                 textAlign: 'center',
//                 fontFamily: '"Playfair Display", serif',
//                 fontSize: { xs: '2rem', md: '2.5rem' }
//               }}
//             >
//               Privacy Policy
//             </Typography>
//             <Divider sx={{ mb: 4, bgcolor: '#1e90d4', height: 2, width: '80px', mx: 'auto' }} />
            
//             <List>
//               {privacyPoints.map((point, index) => (
//                 <ListItem key={index} alignItems="flex-start" sx={{ px: 0, py: 1 }}>
//                   <ListItemText 
//                     primary={
//                       <Typography variant="body1" sx={{ lineHeight: 1.8, color: '#8fb3d9' }}>
//                         <strong style={{ color: '#1e90d4' }}>{index + 1}.</strong> {point}
//                       </Typography>
//                     }
//                   />
//                 </ListItem>
//               ))}
//             </List>
            
//             <Typography sx={{ mt: 3, fontStyle: 'italic', color: '#1e90d4', fontWeight: 600 }}>
//               By using our services, you agree to this Privacy Policy.
//             </Typography>
//           </Box>

//           <Divider sx={{ mb: 6, borderColor: 'rgba(255,255,255,0.1)', borderStyle: 'dashed' }} />

//           {/* --- Section 2: Terms & Conditions --- */}
//           <Box>
//             <Typography 
//               variant="h3" 
//               gutterBottom 
//               sx={{ 
//                 fontWeight: 900, 
//                 color: '#fff', // Header white केला आहे
//                 textAlign: 'center',
//                 fontFamily: '"Playfair Display", serif',
//                 fontSize: { xs: '2rem', md: '2.5rem' }
//               }}
//             >
//               Terms & Conditions
//             </Typography>
//             <Divider sx={{ mb: 4, bgcolor: '#1e90d4', height: 2, width: '80px', mx: 'auto' }} />
            
//             <Box sx={{ color: '#8fb3d9', '& p': { mb: 2.5, lineHeight: 1.8, fontSize: '1.05rem' } }}>
//               <Typography>
//                 This service is provided by <strong>CCTV Partner (Eagle Eye Surveillance)</strong> for security installation, AMC maintenance, and remote monitoring solutions.
//               </Typography>
              
//               <Typography>
//                 Users must not misuse the surveillance systems for any illegal, intrusive, or harmful activities. All technical designs and implementations remain the intellectual property of <strong>CCTV Partner</strong>.
//               </Typography>
              
//               <Typography>
//                 Unauthorized access to monitoring feeds provided by our systems is strictly prohibited. Clients are responsible for maintaining the confidentiality of their own login credentials.
//               </Typography>
              
//               <Typography>
//                 We reserve the right to modify or discontinue certain technical support services based on hardware availability and terms of the AMC. By engaging our services, you agree to these Terms and Conditions.
//               </Typography>
//             </Box>
//           </Box>

//         </Paper>
//       </Container>
//     </Box>
//   );
// };

// export default Privacyinfo; 


import React from 'react';
import { 
  Container, 
  Paper, 
  Typography, 
  Divider, 
  Box, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText,
  Link 
} from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import EmailIcon from '@mui/icons-material/Email';
import LanguageIcon from '@mui/icons-material/Language';

const PrivacyInfo = () => {
  // लिस्ट मधील बुलेट्ससाठी छोटा आयकॉन
  const bulletIcon = (
    <ListItemIcon sx={{ minWidth: 25, mt: 0.8 }}>
      <CircleIcon sx={{ fontSize: 8, color: '#fdfdff' }} />
    </ListItemIcon>
  );

  return (
    <Container maxWidth="md" sx={{ py: 12}}>
      <Paper elevation={3} sx={{ p: { xs: 3, md: 6 }, borderRadius: 2, borderTop: '6px solid #d1d4f5' }}>
        
        {/* Header - Center for better look */}
        <Box textAlign="center" mb={5}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#f8f8fa', mb: 1 }}>
            Privacy Policy
          </Typography>
          <Divider sx={{ width: '100px', height: '3px', bgcolor: '#f5f5f8', mx: 'auto', mb: 2 }} />
        </Box>

        {/* Introduction - Left Aligned */}
        <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.7, textAlign: 'left' }}>
          <strong>CCTV-Partners</strong> respects your privacy. This Privacy Policy explains how our app collects, uses, and protects user information.
        </Typography>

        {/* 1. Information We Collect */}
        <Box mb={4} sx={{ textAlign: 'left' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#fc941e', mb: 1.5 }}>
            Information We Collect
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Our app may collect or access the following information based on features you use:
          </Typography>
          <List disablePadding>
            <ListItem sx={{ alignItems: 'flex-start', py: 0.5 }}>{bulletIcon}<ListItemText primary="Camera access (for capturing photos/videos, if applicable)" /></ListItem>
            <ListItem sx={{ alignItems: 'flex-start', py: 0.5 }}>{bulletIcon}<ListItemText primary="Location access (for location-based features, if applicable)" /></ListItem>
            <ListItem sx={{ alignItems: 'flex-start', py: 0.5 }}>{bulletIcon}<ListItemText primary="Media/Storage access (for selecting or uploading images/files, if applicable)" /></ListItem>
            <ListItem sx={{ alignItems: 'flex-start', py: 0.5 }}>{bulletIcon}<ListItemText primary="Basic device information such as device type, OS version, and app diagnostics" /></ListItem>
          </List>
        </Box>

        {/* 2. How We Use Information */}
        <Box mb={4} sx={{ textAlign: 'left' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#059ac7', mb: 1.5 }}>
            How We Use Information
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>We use information only to:</Typography>
          <List disablePadding>
            <ListItem sx={{ py: 0.5 }}>{bulletIcon}<ListItemText primary="Provide and improve app features" /></ListItem>
            <ListItem sx={{ py: 0.5 }}>{bulletIcon}<ListItemText primary="Enable app functionality requested by users" /></ListItem>
            <ListItem sx={{ py: 0.5 }}>{bulletIcon}<ListItemText primary="Support performance, security, and troubleshooting" /></ListItem>
            <ListItem sx={{ py: 0.5 }}>{bulletIcon}<ListItemText primary="Deliver location-based services (if applicable)" /></ListItem>
          </List>
        </Box>

        {/* 3. Data Sharing */}
        <Box mb={4} sx={{ textAlign: 'left' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#fc941e', mb: 1.5 }}>
            Data Sharing
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>We do not sell personal data. User data may be shared only:</Typography>
          <List disablePadding>
            <ListItem sx={{ py: 0.5 }}>{bulletIcon}<ListItemText primary="With service providers needed to operate app features" /></ListItem>
            <ListItem sx={{ py: 0.5 }}>{bulletIcon}<ListItemText primary="When required by law" /></ListItem>
            <ListItem sx={{ py: 0.5 }}>{bulletIcon}<ListItemText primary="With user consent" /></ListItem>
          </List>
        </Box>

        {/* 4. Data Security & Retention */}
        <Box mb={4} sx={{ textAlign: 'left' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#059ac7', mb: 1.5 }}>
            Data Security & Retention
          </Typography>
          <Typography variant="body2" paragraph>
            We take reasonable measures to protect user information from unauthorized access, misuse, or disclosure.
          </Typography>
          <Typography variant="body2">
            We retain data only as long as necessary to provide app functionality or comply with legal requirements.
          </Typography>
        </Box>

        {/* 5. User Rights */}
        <Box mb={4} sx={{ textAlign: 'left' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#fc941e', mb: 1.5 }}>
            User Rights
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>Users may request:</Typography>
          <List disablePadding sx={{ mb: 2 }}>
            <ListItem sx={{ py: 0.5 }}>{bulletIcon}<ListItemText primary="Access to their data" /></ListItem>
            <ListItem sx={{ py: 0.5 }}>{bulletIcon}<ListItemText primary="Correction of data" /></ListItem>
            <ListItem sx={{ py: 0.5 }}>{bulletIcon}<ListItemText primary="Deletion of data" /></ListItem>
          </List>
          <Typography variant="body2">
            For data deletion requests, contact us at: <strong>cctvpartner@gmail.com</strong>
          </Typography>
        </Box>

        {/* 6. Permissions Used */}
        <Box mb={4} sx={{ textAlign: 'left' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#059ac7', mb: 1.5 }}>
            Permissions Used
          </Typography>
          <List disablePadding>
            <ListItem sx={{ py: 0.5 }}>{bulletIcon}<ListItemText primary="Camera permission for capturing images/content" /></ListItem>
            <ListItem sx={{ py: 0.5 }}>{bulletIcon}<ListItemText primary="Location permission for location-based features" /></ListItem>
            <ListItem sx={{ py: 0.5 }}>{bulletIcon}<ListItemText primary="Media/Storage permission for selecting files or images" /></ListItem>
          </List>
        </Box>

        {/* 7. Children's Privacy & Changes */}
        <Box mb={4} sx={{ textAlign: 'left' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#fc941e', mb: 1 }}>
            Children's Privacy
          </Typography>
          <Typography variant="body2" paragraph>
            This app is not intended for children under 13 and does not knowingly collect data from children.
          </Typography>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#059ac7', mb: 1 }}>
            Changes to This Policy
          </Typography>
          <Typography variant="body2">
            We may update this Privacy Policy from time to time. Changes will be posted on this page.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        {/* Contact Us - Professional Footer */}
        <Box sx={{ textAlign: 'left' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#fc941e' }}>
            Contact Us
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <EmailIcon sx={{ fontSize: 20, mr: 1.5, color: '#059ac7' }} />
            <Typography variant="body2">
              <Link href="mailto:swarsagaramrutparivar@gmail.com" sx={{ color: 'inherit', textDecoration: 'none' }}>
                cctvpartnerr@gmail.com
              </Link>
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <LanguageIcon sx={{ fontSize: 20, mr: 1.5, color: '#fc941e' }} />
            <Typography variant="body2">
              <Link href="https://swarsagaramrut.com" target="_blank" sx={{ color: 'inherit', textDecoration: 'none' }}>
                https://cctvpartner.com/
              </Link>
            </Typography>
          </Box>
        </Box>

        <Typography variant="caption" display="block" sx={{ mt: 5, textAlign: 'center', color: '#999' }}>
          © {new Date().getFullYear()} cctvpartner. All Rights Reserved.
        </Typography>

      </Paper>
    </Container>
  );
};

export default PrivacyInfo;